<p>company-detail-card works!</p>
